<template>
    <div class="relative">
      <!-- what is rating  -->
      <a class="text-sm text-main-text absolute pin-r md:mr-1 cursor-pointer" @click.prevent="$router.push('/results/general')" style="border-bottom:1px #333333 solid;top:-10px">Что такое рейтинг команд?</a>

        <div v-if="teams.length > 0 && cities.length > 0" class="mt-6">
            <team-item class="mt-2 md:mt-5" v-for="(team, key) in teams" ref="teamItem"
                       :team="team" :cities="cities" :index="key" :key="team.id" @notSaved="removeTeamItem($event.id)" />

        </div>
        <div class="flex mt-6 items-center justify-between">
          <div v-if="canAddNewTeam"  class="flex items-center  lg:w-1/2 xl:w-1/2">
            <button class="hover-up outline-none rounded-full flex flex-row justify-center cursor-pointer
            items-center h-8 w-8 bg-brand-light" @click="addTeam">
                <font-awesome-icon class="text-white  text-xl"
                                   :icon="['fal', 'plus']">
                </font-awesome-icon>
            </button>
            <div class="text-xs text-additional-text font-bold ml-4 cursor-pointer" @click="addTeam">Добавить команду</div>
          </div>

          <p class="text-sm text-main-text ml-auto w-1/2 lg:w-full text-right inline-block">Создано: <span class="text-brand-light">{{teams.length}}/{{maxTeams}} команд</span></p>
         <confirm-invite-modal v-if="confirmInviteModal"
          :team_id="teamToJoin"
          :token="teamToken"
          :membership-count="checkMembershipCount"
           @close="confirmInviteModal = false"
           @joined="updateUser"
           @error="errorInvite" />
           <handle-invite-modal v-if="handleInviteModal" :error="errorInviteMessages" :team_name="team_invite_name" @close="handleInviteModal = false" />
        </div>
    </div>
</template>

<script>
import base from '@/clients/base';
import client from '@/clients/player';
import ConfirmInviteModal from './team-layout/confirm-invite-modal.vue';
import TeamItem from './team-layout/team-item';
import { mapState, mapActions } from 'vuex';
import HandleInviteModal from './team-layout/HandleInviteModal.vue';
import cloneDeep from 'lodash/cloneDeep';
import * as Cookies from 'js-cookie';

export default {
  name: 'my-teams',
  components: { TeamItem, ConfirmInviteModal, HandleInviteModal },
  data() {
    return {
      teams: [],
      cities: [],
      countries: {},
      maxTeams: 10,
      confirmInviteModal: false,
      teamToJoin: '',
      teamToken: '',
      team_invite_name: '',
      handleInviteModal: false,
      errorInviteMessages: [],
    };
  },
  created() {
    this.teams = cloneDeep(this.userTeams);
    this.getCities();
    if (this.userTeams) {
      this.inviteHandler();
    }
  },
  methods: {
    ...mapActions(['refreshUser']),
    addTeam() {
      if (this.$refs.teamItem && this.$refs.teamItem.find(item => item.newTeam)) {
        this.$refs.teamItem.find(item => item.newTeam).scrollIntoView;
        return;
      }
      this.teams.push({
        team_name: '',
        players_count: '',
      });
    },
    removeTeamItem(index) {
      this.teams = this.teams.filter((item, indx) => indx !== index);
    },
    errorInvite(messages, name) {
      this.team_invite_name = name;
      this.confirmInviteModal = false;
      this.errorInviteMessages = messages;
      this.handleInviteModal = true;
    },
    updateUser(name) {
      this.team_invite_name = name;
      this.confirmInviteModal = false;
      this.refreshUser(client);
      this.handleInviteModal = true;
    },
    isAlreadyMember(id) {
      const ids = this.teams.map(team => team.id.toString());
      return ids.includes(id);
    },
    getTeamName(id) {
      const teams = this.teams.filter(team => team.id.toString() === id.toString());
      return teams && teams.length > 0 ? teams[0].name : null;
    },
    inviteHandler() {
      if (Cookies.get('invite_team_id')) {
        const id = Cookies.get('invite_team_id');
        if (!this.isAlreadyMember(id)) {
          this.teamToJoin = Cookies.get('invite_team_id');
          this.teamToken = Cookies.get('invite_token');
          Cookies.remove('invite_team_id');
          Cookies.remove('invite_token');
          this.confirmInviteModal = true;
        } else {
          this.handleInviteModal = true;
          this.team_invite_name = this.getTeamName(id);
          this.$set(this.errorInviteMessages, 'team', 'Вы уже являетесь участником этой команды!');
          Cookies.remove('invite_team_id');
          Cookies.remove('invite_token');
          Cookies.remove('invite_team_name');
        }
      }
    },
    getCities() {
      base.get('api/cities/all?sort=name,id')
        .then((response) => {
          this.cities = response.data.data;
        });
    },
  },
  computed: {
    canAddNewTeam() {
      return this.teams.length < this.maxTeams;
    },
    checkMembership() {
      if (this.userTeams) {
        return this.userTeams.filter(team => team.captain.id.toString() !== this.userId.toString())[0];
      }
      return null;
    },
    checkMembershipCount() {
      if (this.userTeams) {
        return this.userTeams.length;
      }
      return 0;
    },
    ...mapState({
      city_id: state => state.user.cityProps.id,
      userTeams: state => state.auth.user.teams,
      userId: state => state.auth.user.id,
    }),
  },
  watch: {
    userTeams: {
      handler() {
        this.teams = cloneDeep(this.userTeams);
        this.inviteHandler();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
